import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["submit", "error", "errorMessage"]
    static values = {
        requiredTypes: Array
    }
    connect() {
        console.log('Simple Import Wizard connected', this.requiredTypesValue)
        this.files = new Map()
        this.updateSubmitButton()
    }

    handleFileValidation(event) {
        const { type, file, variant } = event.detail
        console.log('File validated:', type, file, variant)
        this.files.set(type, { file, variant })
        console.log('Files map:', Array.from(this.files.entries()))
        this.updateSubmitButton()
    }

    handleFileRemoval(event) {
        const { type } = event.detail
        this.files.delete(type)
        this.updateSubmitButton()
    }

    updateSubmitButton() {
        console.log('updateSubmitButton called')
        console.log('requiredTypesValue:', this.requiredTypesValue)
        console.log('files:', Array.from(this.files.entries()))

        const studentInfoEntry = this.files.get('studentInfo')
        const hasWideV2StudentInfo = studentInfoEntry && studentInfoEntry.variant === 'wide_v2'
        const allFilesPresent = this.requiredTypesValue.every(type => this.files.has(type))
        const isReadyToSubmit = hasWideV2StudentInfo || allFilesPresent

        console.log('allFilesPresent:', allFilesPresent, 'hasWideV2StudentInfo:', hasWideV2StudentInfo)

        this.submitTarget.disabled = !isReadyToSubmit
        this.submitTarget.classList.toggle('is-disabled', !isReadyToSubmit)
    }

    submitFiles(event) {

        //disable the submit button
        this.submitTarget.disabled = true
        
        // Hide any previous errors
        this.hideError()

        event.preventDefault()

        const formData = new FormData()
        this.files.forEach((entry, type) => {
            formData.append(`files[${type}]`, entry.file)
        })

        fetch(this.submitTarget.dataset.submitUrl, {
            method: 'POST',
            body: formData,
            headers: {
                'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            redirect: 'follow' // Follow redirects automatically
        })
            .then(response => {
                const contentType = response.headers.get('content-type') || ''

                if (contentType.includes('application/json')) {
                    return response.json().then(data => {
                        if (!response.ok || data.error || data.success === false) {
                            throw new Error(data.message || data.error || 'Upload failed')
                        }

                        const redirectTo = data.redirect_to || this.submitTarget.dataset.successRedirect || '/data-importer'
                        window.location.href = redirectTo
                    })
                }

                if (response.redirected) {
                    window.location.href = response.url
                    return
                }

                if (response.ok) {
                    const successRedirect = this.submitTarget.dataset.successRedirect || '/data-importer'
                    window.location.href = successRedirect
                    return
                }

                // Try to get text error
                return response.text().then(text => {
                    throw new Error(text || 'Upload failed with status ' + response.status)
                })
            })
            .catch(error => {
                // re-enable the submit button
                this.submitTarget.disabled = false
                console.error('Upload failed:', error)
                
                // Show error to user
                const errorMessage = error.message || 'An error occurred while uploading the file. Please try again or contact support.'
                this.showError(errorMessage)
            })
    }
    
    showError(message) {
        if (this.hasErrorTarget && this.hasErrorMessageTarget) {
            this.errorMessageTarget.textContent = message
            this.errorTarget.classList.remove('u-hidden')
        }
    }
    
    hideError() {
        if (this.hasErrorTarget) {
            this.errorTarget.classList.add('u-hidden')
            if (this.hasErrorMessageTarget) {
                this.errorMessageTarget.textContent = ''
            }
        }
    }
}